
import React, { useState, useEffect } from 'react';
import { EMOTION_PRESET } from '../../../sketches/constants/presets';
import EmotionSelector from './EmotionSelector';

function EmotionSelectorContainer({ options, setOptions }) {
    const [selectedEmotion, setSelectedEmotion] = useState("CALM");

    const handleChange = (e) => {
        const { value } = e.target;

        setSelectedEmotion(e.target.value);

        setOptions((prevOptions) => ({
            ...prevOptions,
            emotions: [value],
        }));
    };

    useEffect(() => {
        const selectedPresets = options.emotions.map(
            (emotion) => EMOTION_PRESET[emotion]
        );

        if (selectedPresets.length) {
            const mergedOptions = selectedPresets.reduce(
                (acc, preset) => ({
                    ...acc,
                    ...preset,
                }),
                {}
            );

            setOptions((prevOptions) => ({
                ...prevOptions,
                ...mergedOptions,
            }));
        }
    }, [options.emotions, EMOTION_PRESET, setOptions]);

    return (
        <EmotionSelector
            selectedEmotion={selectedEmotion}
            onEmotionChange={handleChange}
        />
    );
}

export default EmotionSelectorContainer;